import { getAction, postAction, menuGetAction } from "@/request/menage.js";
export default {

  /**
   * 获取Banner图
   * @param {*} client:1
   * @returns 
   */
  getBanner: (params) => getAction("/banner",params),

  /**
   * 箱子类别
   * @returns 
   */
  getBoxCategory: () => getAction("/label"),

  /**
   * 获取箱子图片
   * @param {*} box_id 箱子id 
   * @returns 
   */
  getBoxImg: (params) => getAction("/getBox", params),

  /**
   * 箱子列表
  * @param {*} tag 箱子类别标签id,传空值为全部 
   * @returns 
   */
  gethotbox: (params) => getAction("/hotbox", params),

  /**
   * 箱子详情
   * @param {*} id  箱子id 
   * @param {*} userSeed  用户种子 可不传
   * @returns 
   */
  getBoxDetail: (params) => getAction("/box/detail", params),


/**
 * 开箱记录
 * @param {*} id  箱子id
 * @returns 
 */
  getBoxHistoryList: (params) => getAction("/openhistory", params),

  /**
   * 开箱
   * @param {*} id 箱子id 
   * @param {*} num 开箱数量
   * @param {*} userSeed 用户种子 
   * @param {*} is_fast 是否快速开箱 1快速开箱 0普通开箱(默认-执行开箱动画)
   * @returns 
   */
  handleOpenBox: (params) => postAction("/open", params,{showLoading:false}),

  /**
   * 新手开箱
   * @param {*}  id 箱子id
   * @param {*}  userSeed 用户种子
   * @returns 
   */
  newOpen: (params) => postAction('/new_open', params),

  /**
   * 免费试玩开箱
   * @param {*} id 箱子id 
   * @param {*} num 开箱数量
   * @returns 
   */
  freeTrial: (params) => postAction("/trial", params),


  /**
   * 任务列表
   * @returns 
   */
  taskList: () => getAction("/task_list"),
  
  /**
   * 等级福利箱
   * @returns 
   */
  gradeWelfare: () => getAction("/grade_welfare"),

  /**
   * 活动福利开箱(任务+等级福利箱)
   * @param {*} id 活动编号 
   * @param {*} cdk 兑换码 可不传
   * @returns 
   */
  welfareOpen: (params) => postAction('/welfare/open', params),

  //喜报


}